<!-- 数据统计 -->
<template>
    <Layout>
        <div class="row">
            <div style="width: 100%;" class="flex-depart-center">
                <div class="tabs-box">
                    <div class="tabs-item" @click="changTab(1)">
                        <span :class="{'act-tabs-style':tabNum == 1}">表格视图</span>
                        <label class="blue-tiao" v-if="tabNum == 1"></label>
                    </div>
                    <div class="tabs-item" @click="changTab(2)">
                        <span :class="{'act-tabs-style':tabNum == 2}">统计分析</span>
                        <label class="blue-tiao" v-if="tabNum == 2"></label>
                    </div>
                </div>
                <div class="btns-box flex-depart-center">
                    <el-button round @click="openTimePop">筛选日期</el-button>
                    <el-button type="primary" round v-if="tabNum == 1" @click="toPageDaoChu">导出数据</el-button>
                    <el-button type="primary" round v-if="tabNum == 2" @click="daoChuData">导出分析数据</el-button>
                </div>
            </div>
            <div style="width: 100%;background-color: white" class="b-marT-10">
                <div class="table-responsive" v-if="tabNum == 1">
                    <table class="table table-hover mb-0 table-width">
                        <thead>
                        <tr>
                            <th v-for="item in theadList" :key="item.key">
                                <span class="no-wrap">{{ item.title }}</span>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(row, index) in tbodyList" :key="index">
                            <th scope="row">{{ index + 1 }}</th>
                            <td>
                                <span class="no-wrap">
                                    {{ row.registrationId }}
                                </span>
                            </td>
                            <td>
                                <span class="no-wrap">
                                    {{ row.wxName }}
                                </span>
                            </td>
                            <td v-for="(head, i) in theadList.slice(3)" :key="i">
                                <!-- 图片 -->
                                <div v-if="head.type === '5'" class="no-wrap colorBlue" @click="seeBigImg(row[head.key],1)">
                                    {{ (row[head.key] && row[head.key].length) || 0 }}张,[查看图片]
                                </div>
                                <!-- 文件 -->
                                <div v-else-if="head.type === '32'">
                                    <div v-if="!row[head.key] || row[head.key].length === 0" class="no-wrap">
                                        -
                                    </div>
                                    <div v-else v-for="(fItem,fileIndex) in row[head.key]" :key="fileIndex" class="no-wrap colorBlue position-relative" @click="seeFile(fItem,fileIndex)">
                                        {{ fItem.name }}
                                        <a :href="imageUrl + fItem.fileUrl" download=""></a>
                                    </div>
                                </div>
                                <!-- 视频 -->
                                <div v-else-if="head.type === '6'" class="colorBlue" @click="seeVideo(row[head.key])">
                                    <video width="100" height="100" controls>
                                        <source :src="imageUrl + row[head.key]" type="video/mp4">
                                    </video>
                                </div>
                                <!-- 音频 -->
                                <div v-else-if="head.type === '7'" class="colorBlue" @click="onPlay(row[head.key])">
                                    <audio controls width="100" height="100">
                                        <source :src="row[head.key].url" type="audio/ogg">
                                    </audio>
                                </div>
                                <!-- 签名 -->
                                <div v-else-if="head.type === '29'" class="no-wrap colorBlue" @click="seeSignature(row[head.key])">
                                    [查看签名]
                                </div>
                                <!-- 所在位置 -->
                                <div v-else-if="head.type === '12'">
                                    {{ (row[head.key] && row[head.key].address) || '-' }}
                                </div>
                                <!-- 文件签字-->
                                 <div v-else-if="head.type === '36'" class="no-wrap colorBlue" @click="seeSignFileImg(row[head.key],1)">
                                    {{ (row[head.key] && row[head.key].length) || 0 }}张,[查看图片]
                                </div>
                                <!-- 其他 -->
                                <div v-else class="no-wrap" @click="seeData(row[head.key],index)">{{ row[head.key] || '-' }}</div>
                            </td>
                        </tr>

                        </tbody>
                    </table>
                    <!-- 分页 -->
                    <div style="text-align: center; margin-top: 20px" v-if="!nodataShow && tbodyList.length > 0">
                        <el-pagination
                            background
                            layout="sizes,prev, pager, next,total"
                            :page-sizes="[10, 20, 50, 100]"
                            :total="totalCount"
                            :current-page="currentPage"
                            :page-size="pageSize"
                            @size-change="handleSizeChange"
                            @current-change="handlePageChange"
                        >
                        </el-pagination>
                    </div>
                    <!-- 暂无数据 -->
                    <div class="nodata-box" v-if="nodataShow == true">
                        <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/tjfx-nodata.svg" alt="">
                        <span>暂无数据</span>
                    </div>
                </div>
                <div class="s-analysis" v-if="tabNum == 2">
                    <div class="tips">统计分析支持的字段有：单选、多选，并剔除了已经取消的数据。</div>
                    <div v-for="(item) in analysisData" :key="item.type" class="table-box table-box2">
                        <div class="t-title">{{ item.question.split('/')[0] }}[{{ item.type }}]</div>
                        <table class="table table-hover mb-0 table-width">
                            <!-- 表头行 -->
                            <thead>
                            <tr>
                                <th>选项</th>
                                <th>小计</th>
                                <th>比例</th>
                            </tr>
                            </thead>
                            <tbody>
                            <!-- 表格数据行 -->
                            <tr v-for="(option, optIndex) in item.options" :key="optIndex">
                                <td align="left">{{ option.label }}</td>
                                <td align="left">{{ option.count }}</td>
                                <td align="left">{{ option.percentage }}</td>
                            </tr>
                            <!-- 合计行 -->
                            <tr>
                                <td align="left">合计</td>
                                <td align="left">{{ item.total.count }}</td>
                                <td align="left">{{ item.total.percentage }}</td>
                            </tr>
                            </tbody>

                        </table>
                    </div>
                    <div class="nodata-box" v-if="nodataShow == true">
                        <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/tjfx-nodata.svg" />
                        <span>暂无数据</span>
                    </div>
                </div>
            </div>

            <el-dialog
                    title="筛选导出范围"
                    :visible.sync="filterTimesBoxShow"
                    width="450px"
                    :before-close="cancelFTSet" :show-close="false">
                    <template slot="title">
                        <CustomDialogHeader
                            title="筛选导出范围"
                            @close="filterTimesBoxShow = false"
                        />
                    </template>
                <div class="s-times-box">
                    <div class="times-item"
                          v-for="(item,index) in timeFilterArr" :key="item.type"
                          :class="{'times-item-active': index == filterDateArr[filterDateType].currentDateIndex}" @click="currentSelect(item,index)">
                        {{ item.title }}
                    </div>
                </div>
                <div class="sort-box">
                    <div class="sort-title">自定义日期</div>
                    <div class="timeRangeOutBox flex-depart-center">
                        <el-date-picker
                                v-model="filterDateArr[filterDateType].startQueryTime"
                                type="date"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                placeholder="选择日期">
                        </el-date-picker>
                        <span style="padding-left: 10px;padding-right: 10px">-</span>
                        <el-date-picker
                                v-model="filterDateArr[filterDateType].endQueryTime"
                                type="date"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                placeholder="选择日期">
                        </el-date-picker>
                    </div>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="cancelFTSet">取 消</el-button>
                    <el-button type="primary" @click="submitFn">确 定</el-button>
                </span>
            </el-dialog>

            <el-dialog
                    title="查看"
                    :visible.sync="photoShow"
                    width="900px" @close="closeSwiper" :show-close="false">
                    <template slot="title">
                        <CustomDialogHeader
                            title="查看"
                            @close="closeSwiper"
                        />
                    </template>
                <div>
                    <el-carousel indicator-position="outside" height="550px">
                        <el-carousel-item v-for="item in photoList" :key="item">
                            <div style="text-align: center">
                                <img class="swiper-img" :src="item" alt="">
                            </div>
                        </el-carousel-item>
                    </el-carousel>
                </div>

            </el-dialog>
        </div>
    </Layout>
</template>
<script>
    import CustomDialogHeader from '@/components/CustomDialogHeader.vue'
    import Layout from "../../layouts/main";
    import appConfig from "@/app.config";

    import { imageUrl } from "@/utils/config/commonUrl.js";

    import {
        tableAttempting,
        listAnalysis,
        listAnalysisExport,
    } from "@/utils/api/activity";
    import { activityDetail} from "@/utils/api/build";

    var dayjs = require('dayjs')
    const d = new Date()
    const year = d.getFullYear()
    let month = d.getMonth() + 1
    month = month < 10 ? `0${month}` : month
    const date = d.getDate()

    export default {
        page(){
            return {
                title: `${this.actName} - 数据统计`,
                meta: [{ name: "description", content: appConfig.description }],
            }
        },
        components: { Layout ,CustomDialogHeader},
        data() {
            return {
                value1: '',
                imageUrl: imageUrl,
                // 数据统计
                value: '7878',
                theadList: [],
                tbodyList: [],
                rawData: [
                    //     [{"fieldName": "姓名", "type": "1", "id": "16690", "value": "二"}, {
                    //     "fieldName": "数量",
                    //     "type": "13",
                    //     "id": "16691",
                    //     "value": "34"
                    // }, {
                    //     "fieldName": "请上传图片",
                    //     "type": "5",
                    //     "id": "16692",
                    //     "value": ["8q3ql1afekXCuyoZ/modularImg/1744791800152.jpg"]
                    // }, {"fieldName": "单选", "type": "2", "id": "16693", "value": "星期一"}, {
                    //     "fieldName": "多选",
                    //     "type": "4",
                    //     "id": "16694",
                    //     "value": ["星期六"]
                    // }, {
                    //     "fieldName": "文件",
                    //     "type": "32",
                    //     "id": "16695",
                    //     "value": [{
                    //         "lastName": "xlsx",
                    //         "size": 14167,
                    //         "name": "1743039859861.xlsx",
                    //         "fileUrl": "8q3ql1afekXCuyoZ/modularFile/1744791809948.xlsx"
                    //     }]
                    // }, {
                    //     "fieldName": "请填写视频标题",
                    //     "type": "6",
                    //     "id": "16696",
                    //     "value": "8q3ql1afekXCuyoZ/modularMP4/1744791832238.mp4"
                    // }, {
                    //     "fieldName": "签名",
                    //     "type": "29",
                    //     "id": "16697",
                    //     "value": "8q3ql1afekXCuyoZ/modularImg/1744791842801.png"
                    // }, {
                    //     "fieldName": "请填写音频标题",
                    //     "type": "7",
                    //     "id": "16698",
                    //     "value": {
                    //         "url": "https://ossfastmake.mustke.com/8q3ql1afekXCuyoZ/modularMP3/1744791862121.mp3",
                    //         "size": 6697394,
                    //         "name": "李荣浩 - 情人.mp3",
                    //         "time": ""
                    //     }
                    // }, {
                    //     "fieldName": "微信名称",
                    //     "type": "999",
                    //     "wx_profile_photo": "https://osssec.mustke.com/sysImg/userImg/1595487889275.jpg",
                    //     "value": "微信用户"
                    // }], [{"fieldName": "姓名", "type": "1", "id": "16690", "value": "花生什么树了"}, {
                    //     "fieldName": "数量",
                    //     "type": "13",
                    //     "id": "16691",
                    //     "value": "2"
                    // }, {
                    //     "fieldName": "请上传图片",
                    //     "type": "5",
                    //     "id": "16692",
                    //     "value": ["kEu47kwFr2oOr9rO/modularImg/1744793092632.jpg"]
                    // }, {"fieldName": "单选", "type": "2", "id": "16693", "value": "星期一"}, {
                    //     "fieldName": "多选",
                    //     "type": "4",
                    //     "id": "16694",
                    //     "value": ["星期六"]
                    // }, {
                    //     "fieldName": "文件",
                    //     "type": "32",
                    //     "id": "16695",
                    //     "value": [{
                    //         "lastName": "pdf",
                    //         "size": 146728,
                    //         "name": "鸭货.pdf",
                    //         "fileUrl": "kEu47kwFr2oOr9rO/modularFile/1744793126733.pdf"
                    //     }]
                    // }, {
                    //     "fieldName": "请填写视频标题",
                    //     "type": "6",
                    //     "id": "16696",
                    //     "value": "kEu47kwFr2oOr9rO/modularMP4/1744793147610.mp4"
                    // }, {
                    //     "fieldName": "签名",
                    //     "type": "29",
                    //     "id": "16697",
                    //     "value": "kEu47kwFr2oOr9rO/modularImg/1744793150719.png"
                    // }, {
                    //     "fieldName": "请填写音频标题",
                    //     "type": "7",
                    //     "id": "16698",
                    //     "value": {
                    //         "url": "https://ossfastmake.mustke.com/kEu47kwFr2oOr9rO/modularMP3/1744793185386.mp3",
                    //         "size": 1922016,
                    //         "name": "85555774(85555774)_20240923092315.mp3",
                    //         "time": ""
                    //     }
                    // }, {
                    //     "fieldName": "微信名称",
                    //     "type": "999",
                    //     "wx_profile_photo": "https://osssec.mustke.com/sysImg/userImg/1595487799716.jpg",
                    //     "value": "微信用户"
                    // }]
                ],
                headers: [],
                tabNum: 1,
                currentDateIndex: 0,
                filterDateType: 0,
                filterDateArr:[
                    {
                        startQueryTime: '',
                        endQueryTime: '',
                        currentDateIndex: 0,
                    },
                    {
                        startQueryTime: '',
                        endQueryTime: '',
                        currentDateIndex: 0,
                    },

                ],
                filterTimesBoxShow: false,
                timeFilterArr: [
                    {
                        title: '全部',
                        active: true,
                        type: 0
                    },
                    {
                        title: '今天',
                        active: false,
                        type: 1
                    },
                    {
                        title: '昨天',
                        active: false,
                        type: 2
                    },
                    {
                        title: '最近三天',
                        active: false,
                        type: 3
                    },
                    {
                        title: '本周',
                        active: false,
                        type: 4
                    },
                    {
                        title: '上周',
                        active: false,
                        type: 5
                    },
                    {
                        title: '本月',
                        active: false,
                        type: 6
                    },
                    {
                        title: '上月',
                        active: false,
                        type: 7
                    }
                ],
                timeValueNew: '',
                startTimePopShow: false,
                endTimePopShow: false,
                filterTimesShow: false,
                FilterTimeArr: [
                    {
                        title: '全部',
                        active: true,
                        type: 0
                    },
                    {
                        title: '今天',
                        active: false,
                        type: 1
                    },
                    {
                        title: '昨天',
                        active: false,
                        type: 2
                    },
                    {
                        title: '最近三天',
                        active: false,
                        type: 3
                    },
                    {
                        title: '本周',
                        active: false,
                        type: 4
                    },
                    {
                        title: '上周',
                        active: false,
                        type: 5
                    },
                    {
                        title: '本月',
                        active: false,
                        type: 6
                    },
                    {
                        title: '上月',
                        active: false,
                        type: 7
                    }
                ],
                sTime: '',
                eTime: '',

                timeBoxShow1: false,
                timeBoxShow2: false,


                startTime: '',
                endTime: '',
                timeValue: '自定义日期',
                startQueryTime: '',
                endQueryTime: '',
                minDateMultiple: '',
                defaultDateMultiple: [`${year}-${month}-${date-1}`],
                startTimeShow: false,
                endTimeShow: false,
                signInfo: [],
                actInfo: {},
                isInitialized: false,
                loading: false,
                actName: '',
                // 分析数据
                analysisData: [
                    // {
                    //     "total": {
                    //         "percentage": "100%",
                    //         "count": 2
                    //     },
                    //     "question": "单选/15646",
                    //     "options": [
                    //         {
                    //             "percentage": "50.00%",
                    //             "count": 1,
                    //             "label": "1"
                    //         },
                    //         {
                    //             "percentage": "50.00%",
                    //             "count": 1,
                    //             "label": "2"
                    //         },
                    //         {
                    //             "percentage": "0.00%",
                    //             "count": 0,
                    //             "label": "3"
                    //         }
                    //     ],
                    //     "type": "单选"
                    // },
                    // {
                    //     "total": {
                    //         "percentage": "100%",
                    //         "count": 2
                    //     },
                    //     "question": "多选/15647",
                    //     "options": [
                    //         {
                    //             "percentage": "50.00%",
                    //             "count": 1,
                    //             "label": "11"
                    //         },
                    //         {
                    //             "percentage": "0.00%",
                    //             "count": 0,
                    //             "label": "22"
                    //         },
                    //         {
                    //             "percentage": "50.00%",
                    //             "count": 1,
                    //             "label": "33"
                    //         }
                    //     ],
                    //     "type": "多选"
                    // }
                ],
                imageUrl2: this.imageUrl,
                seeSignatureImgShow: false,
                signatureImgSrc: '',
                innerAudioContext: '',
                seeVideoShow: false,
                videoShow: false,
                videoUrl: '',
                nodataShow: false,
                dataDrawerShow: false,
                direction: 'rtl',
                tableData: [{
                    date: '2016-05-02',
                    name: '王小虎',
                    province: '上海',
                    city: '普陀区',
                    address: '上海市普陀区金沙江路 1518 弄',
                    zip: 200333
                }, {
                    date: '2016-05-04',
                    name: '王小虎',
                    province: '上海',
                    city: '普陀区',
                    address: '上海市普陀区金沙江路 1517 弄',
                    zip: 200333
                }, {
                    date: '2016-05-01',
                    name: '王小虎',
                    province: '上海',
                    city: '普陀区',
                    address: '上海市普陀区金沙江路 1519 弄',
                    zip: 200333
                }, {
                    date: '2016-05-03',
                    name: '王小虎',
                    province: '上海',
                    city: '普陀区',
                    address: '上海市普陀区金沙江路 1516 弄',
                    zip: 200333
                }],
                routeParameter: {},
                photoList: [],
                photoShow: false,
                activityKey: '',
                // 分页相关
                currentPage: 1,
                pageSize: 10,
                totalCount: 0,

            };
        },
        created() {

        },
        mounted(){
            // 页面参数
            this.routeParameter = this.$route.query;
            console.log('页面路由参数', this.routeParameter);

            if (this.routeParameter.activityId){
                this.activityId = this.routeParameter.activityId;
                console.log('设置 activityId', this.activityId);
            }
            if (this.routeParameter.alias){
                this.activityKey = this.routeParameter.alias;
                console.log('设置 activityKey', this.activityKey);
            }

            if (!this.activityKey) {
                console.error('缺少 activityKey 参数');
                return;
            }

            this._activityDetail()
        },
        methods: {
            // 数据统计 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
            closeSwiper(){
                this.photoList = [];
            },
            openTimePop(){
                this.filterDateType = this.tabNum - 1;
                this.filterTimesBoxShow = true;
            },
            handleClick(row) {
                console.log(row);
            },
            toPageStatistics(row){
                this.dataDrawerShow = true;
            },
            dataDrawerClose(){
                this.dataDrawerShow = false;
            },

            onPlay(val){
                // const bgAudioManager = uni.getBackgroundAudioManager();
                // bgAudioManager.title = val.name;  // 音频标题，必填
                // bgAudioManager.epname = '音频播放';  // 专辑名
                // // bgAudioManager.singer = '未知';  // 歌手名
                // // bgAudioManager.coverImgUrl = 'https://example.com/default-cover.jpg'; // 封面图，可选
                // bgAudioManager.src = val.url;  // 音频链接，必填
                // bgAudioManager.audioType = 'audio';
                // // 监听播放结束
                // bgAudioManager.onEnded(() => {
                //
                // });
            },
            seeVideo(val){
                console.log(val);
                this.videoUrl = this.imageUrl + val;
                this.videoShow = true;
                this.seeVideoShow = true;
            },
            // 查看大图
            seeBigImg(val,type){
                if (!val) {
                    return
                }
                if (type == 1){
                    this.photoList = val.map(item => {
                        return this.imageUrl + item
                    })
                    this.photoShow = true;

                }

            },
              seeSignFileImg(val,type){
              if (!val) {
                    return
                }
                if (type == 1){
                    this.photoList = val.map(item => {
                        return item
                    })
                    this.photoShow = true;
                }
            },
            seeSignature(val){
                this.signatureImgSrc = this.imageUrl + val;
                this.seeSignatureImgShow = true;
                this.photoList = [this.signatureImgSrc];
                this.photoShow = true;
            },
            close(type){
                if (type === 'Signature'){
                    this.seeSignatureImgShow = false
                }
                if (type === 'video'){
                    this.seeVideoShow = false;
                    this.videoShow = false;
                }
            },
            // 查看文件
            seeFile(fItem,fileIndex){
                console.log(fItem,fileIndex,'文件哦')

            },
            changTab(num){
                this.tabNum = num;
            },
            timeRangeConfirmFn1(e){
                this.startQueryTime = e[0]
                this.startTimeShow = false;
            },

            timeRangeConfirmFn2(e){
                this.endQueryTime = e[0]
                this.endTimeShow = false;
            },
            timeRangeConfirmFn3(e){
                this.sTime = e[0]
                this.startTimePopShow = false;
            },

            timeRangeConfirmFn4(e){
                this.eTime = e[0]
                this.endTimePopShow = false;
            },
            cancelFTSet(){
                this.filterTimesBoxShow = false;
                this.filterTimesShow = false;
            },
            // 统一管理弹窗关闭方法
            closePopup(type) {
                console.log(type)
                switch(type) {
                    case 'select':
                        this.selectBoxShow = false;
                        break;
                    case 'filterTimesNew':
                        this.filterTimesShow = false;
                        break;
                    case 'filterTimes':
                        this.filterTimesBoxShow = false;
                        break;
                    case 'timeRange':
                        this.timeShow = false;
                        break;
                }
            },
            // 视图
            async _tableAttempting(){
                console.log('开始获取表格数据', {
                    activityKey: this.activityKey,
                    startQueryTime: this.startQueryTime,
                    endQueryTime: this.endQueryTime,
                    currentPage: this.currentPage,
                    pageSize: this.pageSize
                });

                let result = await tableAttempting({
                    activityKey: this.activityKey,    //活动id
                    startQueryTime: this.startQueryTime,   //开始时间
                    endQueryTime: this.endQueryTime,    //结束时间
                    pageNum: this.currentPage,    //当前页
                    pageSize: this.pageSize    //每页大小
                })

                console.log('API返回结果', result);

                if (result.status == 1){
                    this.isInitialized = false;
                    const loading = this.$loading({
                        lock: true,
                        text: '加载中...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    // 处理API返回的数据结构：result.data.list 是实际的数据数组
                    let dataArray = [];
                    if (result.data && result.data.list && Array.isArray(result.data.list)) {
                        dataArray = result.data.list;
                        // 设置总数量
                        this.totalCount = result.data.total || result.data.count || dataArray.length;
                    } else if (Array.isArray(result.data)) {
                        dataArray = result.data;
                        this.totalCount = dataArray.length;
                    }
                    this.rawData = dataArray;
                    console.log('设置 rawData', this.rawData, 'totalCount', this.totalCount);

                    this.$nextTick(()=>{
                        this.filterTimesBoxShow = false;
                        this.processData()
                        setTimeout(()=>{
                            loading.close();
                            // 不再重复设置 isInitialized 和 nodataShow，因为 processData 已经处理了
                        },800)
                    })
                } else {
                    console.log('API调用失败', result);
                    // 如果API调用失败，确保 rawData 是空数组
                    this.rawData = [];
                    this.theadList = [];
                    this.tbodyList = [];
                    this.totalCount = 0;
                    this.nodataShow = true;
                    this.isInitialized = true;
                }
            },
            async _listAnalysisExport(){
                let result = await listAnalysisExport({
                    activityId: this.activityId,
                    startQueryTime: this.sTime,   //开始时间
                    endQueryTime: this.eTime    //结束时间
                })

                if (result.status == 1){
                    this.loading.close();
                    if (result.msg === '-1'){
                        this.$message('暂无数据，请重新筛选');
                        return false;
                    }
                    this.filterTimesShow = false;
                    // 编码
                    var downloadUrl = '';
                    downloadUrl = encodeURIComponent(result.msg);
                    var actName = '';
                    actName = encodeURIComponent(this.actName);
                    let routeData = this.$router.resolve({
                        path: "/exportSuccessPage?downloadUrl=" + downloadUrl + '&actName=' + actName,
                    });
                    window.open(routeData.href, "_blank");
                } else {
                    this.loading.close();
                    this.$message('result.msg');
                }
            },
            seeData(val,index){
                console.log(val,index,'今天星期四啦')
            },
            // processData() {
            //     // 检查 rawData 是否为有效数组
            //     if (!Array.isArray(this.rawData) || this.rawData.length === 0) {
            //         this.theadList = [];
            //         this.tbodyList = [];
            //         return;
            //     }

            //     // 生成表头
            //     const headers = new Map();
            //     headers.set('wx', {
            //         title: '微信名称',
            //         key: 'wx',
            //         type: 999
            //     });

            //     // 处理表头
            //     this.rawData.forEach(row => {
            //         if (!Array.isArray(row)) return; // 确保 row 是数组
            //         row.forEach(field => {
            //             if(field.fieldName === '微信名称') return;
            //             const key = field.id || '999'; // 微信名称特殊处理
            //             if(!headers.has(key)) {
            //                 headers.set(key, {
            //                     title: field.fieldName,
            //                     key: key,
            //                     type: field.type
            //                 });
            //             }
            //         });
            //     });

            //     // 转换为数组并排序
            //     this.theadList = [
            //         { title: '序号', key: 'index' },
            //         ...Array.from(headers.values()).filter(d => d.title === '微信名称'),
            //         ...Array.from(headers.values()).filter(d => d.title !== '微信名称')
            //     ];

            //     // 处理表格数据
            //     this.tbodyList = this.rawData.map(row => {
            //         if (!Array.isArray(row)) return { wxName: '' }; // 确保 row 是数组
            //         const item = { wxName: '' };
            //         row.forEach(field => {
            //             if(field.fieldName === '微信名称') {
            //                 item.wxName = field.value;
            //                 return;
            //             }

            //             const key = field.id || '999';
            //             let value = field.value;

            //             // 处理多选类型
            //             if([2,4].includes(Number(field.type)) && Array.isArray(value)) {
            //                 value = value.join(',');
            //             }

            //             item[key] = value;
            //         });
            //         return item;
            //     });
            // },
            processData() {
                console.log('开始处理数据', this.rawData);

                // 检查 rawData 是否为有效数组
                if (!Array.isArray(this.rawData) || this.rawData.length === 0) {
                    console.log('rawData 不是有效数组或为空', this.rawData);
                    this.theadList = [];
                    this.tbodyList = [];
                    this.totalCount = 0;
                    this.nodataShow = true;
                    this.isInitialized = true;
                    return;
                }

                // 生成表头
                const headers = new Map();
                headers.set('registrationId', {
                    title: '报名id',
                    key: 'registrationId',
                    type: 333
                });
                headers.set('wx', {
                    title: '微信名称',
                    key: 'wx',
                    type: 999
                });

                // 处理表头
                this.rawData.forEach(row => {
                    row.forEach(field => {
                        if(field.fieldName === '微信名称' || field.fieldName === '报名id' ) return;
                        const key = field.id || '999';
                        if(!headers.has(key)) {
                            headers.set(key, {
                                title: field.fieldName,
                                key: key,
                                type: field.type
                            });
                        }
                    });
                });

                // 转换为数组并排序
                // this.theadList = [
                //     { title: '序号', key: 'index' },
                //     ...Array.from(headers.values()).filter(d => d.title === '微信名称'),
                //     ...Array.from(headers.values()).filter(d => d.title !== '微信名称')
                // ];

                // 转换为数组并排序
                this.theadList = [
                    { title: '序号', key: 'index' },
                    ...Array.from(headers.values()).filter(d => d.title === '报名id'),
                    ...Array.from(headers.values()).filter(d => d.title === '微信名称'),
                    ...Array.from(headers.values()).filter(d => d.title !== '微信名称' && d.title !== '报名id')
                ];

                // 处理表格数据
                this.tbodyList = this.rawData.map(row => {
                    if (!Array.isArray(row)) {
                        console.log('row 不是数组，跳过', row);
                        return { wxName: '' };
                    }
                    const item = { wxName: '', registrationId: '' };
                    row.forEach(field => {
                        if(field.fieldName === '微信名称') {
                            item.wxName = field.value;
                            return;
                        }

                        if(field.fieldName === '报名id') {
                            item.registrationId = field.value;
                            return;
                        }

                        const key = field.id || '999';
                        let value = field.value;

                        // 处理多选类型
                        if([2,4].includes(Number(field.type)) && Array.isArray(value)) {
                            value = value.join(',');
                        }

                        item[key] = value;
                    });
                    return item;
                });

                console.log('处理完成', {
                    theadList: this.theadList,
                    tbodyList: this.tbodyList,
                    nodataShow: this.tbodyList.length === 0
                });

                this.isInitialized = true;
                this.nodataShow = this.tbodyList.length === 0;
            },
            // 处理数组值显示
            formatValue(value, type) {
                if (type === '999') {
                    return {
                        value: value,
                        wx_profile_photo: value
                    }
                }
                return Array.isArray(value) ? value.join(', ') : value
            },

            // 统计分析
            async _listAnalysis(){
                let result = await listAnalysis({
                    activityId: this.activityId,    //活动id
                    startQueryTime: this.startQueryTime,   //开始时间
                    endQueryTime: this.endQueryTime    //结束时间
                })
                if (result.status == 1){
                    // 处理API返回的数据结构：result.data.list 是实际的数据数组
                    let dataArray = [];
                    if (result.data && result.data.list && Array.isArray(result.data.list)) {
                        dataArray = result.data.list;
                    } else if (Array.isArray(result.data)) {
                        dataArray = result.data;
                    }
                    this.analysisData = dataArray;
                    if (this.analysisData.length){
                        this.nodataShow = false;
                    } else {
                        this.nodataShow = true;
                    }
                } else {
                    // 如果API调用失败，确保 analysisData 是空数组
                    this.analysisData = [];
                    this.nodataShow = true;
                }
                this.filterTimesBoxShow = false;
            },

            // 获取活动详情
            async _activityDetail() {
                console.log('开始获取活动详情', this.activityKey);
                var obj = {
                    "activityKey": this.activityKey,
                    "selectType": 'see',
                }
                const {
                    data,
                    msg,
                    status
                } = await activityDetail(obj)
                console.log('活动详情API返回', { data, msg, status });

                if (status == 1) {
                    this.activityId = data.activityDetail.id
                    this.actName = data.activityDetail.name;
                    this.actInfo = data.activityDetail;
                    this.minDateMultiple = data.activityDetail.beginTime.substring(0,10)
                    console.log('设置活动信息', {
                        activityId: this.activityId,
                        actName: this.actName,
                        activityKey: this.activityKey
                    });
                    this._tableAttempting()
                    this._listAnalysis()
                } else {
                    console.log('获取活动详情失败', msg);
                }
            },

            currentSelect(item,idx) {
                console.log(item.type,'typene')
                this.filterDateArr[this.filterDateType].currentDateIndex = idx;
                this.timeFilterArr.forEach(v => v.active = false)
                item.active = true

                const padZero = n => n.toString().padStart(2, '0')
                const format = date => `${date.getFullYear()}-${padZero(date.getMonth() + 1)}-${padZero(date.getDate())}`

                const today = new Date()
                let start, end

                switch(item.type) {
                    case 0: // 全部
                        this.startTime = ''
                        this.endTime = ''
                        this.timeValue = '自定义日期';
                        this.startQueryTime = '';
                        this.endQueryTime = '';
                        this.filterDateArr[this.filterDateType].startQueryTime = this.startQueryTime
                        this.filterDateArr[this.filterDateType].endQueryTime = this.endQueryTime
                        return

                    case 1: // 今天
                        start = end = today
                        break

                    case 2: // 昨天
                        var yesterday = new Date(today)
                        yesterday.setDate(today.getDate() - 1)
                        start = end = yesterday
                        break

                    case 3: // 最近三天
                        start = new Date(today)
                        start.setDate(today.getDate() - 2)
                        end = today
                        break

                    case 4: // 本周（周一到周日）
                        start = new Date(today)
                        // 计算到本周一的差值（当today.getDay()=1(周一)时，差0天）
                        var dayDiff = (today.getDay() + 6) % 7
                        start.setDate(today.getDate() - dayDiff)
                        end = new Date(start)
                        end.setDate(start.getDate() + 6)
                        break

                    case 5: // 上周（周一到周日）
                        // 先找到本周一
                        var thisMonday = new Date(today)
                        thisMonday.setDate(today.getDate() - ((today.getDay() + 6) % 7))
                        // 上周日是本周一减1天
                        end = new Date(thisMonday)
                        end.setDate(thisMonday.getDate() - 1)
                        // 上周一是上周日减6天
                        start = new Date(end)
                        start.setDate(end.getDate() - 6)
                        break

                    case 6: // 本月（1号到当月最后一天）
                        start = new Date(today.getFullYear(), today.getMonth(), 1)
                        end = new Date(today.getFullYear(), today.getMonth() + 1, 0) // 关键修改点
                        break

                    case 7: // 上月
                        start = new Date(today.getFullYear(), today.getMonth() - 1, 1)
                        end = new Date(today.getFullYear(), today.getMonth(), 0)
                        break
                }

                this.startTime = format(start)
                this.endTime = format(end)

                this.startQueryTime = this.startTime;
                this.endQueryTime = this.endTime;

                this.filterDateArr[this.filterDateType].startQueryTime = this.startQueryTime
                this.filterDateArr[this.filterDateType].endQueryTime = this.endQueryTime

                this.timeValue = this.startQueryTime + ' ~ ' + this.endQueryTime

            },
            currentSelectNew(item) {
                console.log(item.type,'typene')
                this.FilterTimeArr.forEach(v => v.active = false)
                item.active = true

                const padZero = n => n.toString().padStart(2, '0')
                const format = date => `${date.getFullYear()}-${padZero(date.getMonth() + 1)}-${padZero(date.getDate())}`

                const today = new Date()
                let start, end

                switch(item.type) {
                    case 0: // 全部
                        this.sTime = ''
                        this.eTime = ''
                        this.timeValueNew = '自定义日期';
                        this.startQueryTime = '';
                        this.endQueryTime = '';
                        return

                    case 1: // 今天
                        start = end = today
                        break

                    case 2: // 昨天
                        var yesterday = new Date(today)
                        yesterday.setDate(today.getDate() - 1)
                        start = end = yesterday
                        break

                    case 3: // 最近三天
                        start = new Date(today)
                        start.setDate(today.getDate() - 2)
                        end = today
                        break

                    case 4: // 本周（周一到周日）
                        start = new Date(today)
                        // 计算到本周一的差值（当today.getDay()=1(周一)时，差0天）
                        var dayDiff = (today.getDay() + 6) % 7
                        start.setDate(today.getDate() - dayDiff)
                        end = new Date(start)
                        end.setDate(start.getDate() + 6)
                        break

                    case 5: // 上周（周一到周日）
                        // 先找到本周一
                        var thisMonday = new Date(today)
                        thisMonday.setDate(today.getDate() - ((today.getDay() + 6) % 7))
                        // 上周日是本周一减1天
                        end = new Date(thisMonday)
                        end.setDate(thisMonday.getDate() - 1)
                        // 上周一是上周日减6天
                        start = new Date(end)
                        start.setDate(end.getDate() - 6)
                        break

                    case 6: // 本月（1号到当月最后一天）
                        start = new Date(today.getFullYear(), today.getMonth(), 1)
                        end = new Date(today.getFullYear(), today.getMonth() + 1, 0) // 关键修改点
                        break

                    case 7: // 上月
                        start = new Date(today.getFullYear(), today.getMonth() - 1, 1)
                        end = new Date(today.getFullYear(), today.getMonth(), 0)
                        break
                }

                this.sTime = format(start)
                this.eTime = format(end)

                this.timeValueNew = this.sTime + ' ~ ' + this.eTime

            },
            toPageDaoChu(){
                if (this.nodataShow == true){
                    this.$message('暂无数据');
                    return;
                }
                let routeData = this.$router.resolve({
                    path: "/exportDataPage?alias=" + this.activityKey,
                });
                window.open(routeData.href, "_blank");
            },
            daoChuData(){
                if (this.nodataShow == true){
                    this.$message('暂无数据');
                    return;
                }
                this.loading = this.$loading({
                    lock: true,
                    text: '上传中...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this._listAnalysisExport()
            },

            cancelStep(){
                this.filterTimesBoxShow = false;
                this.filterTimesShow = false;
            },
            clearTimeVal(){
                this.startQueryTime = '';
                this.endQueryTime = '';
                this.timeFilterArr.forEach(v => v.active = false)
                this.timeFilterArr[0].active = true;
                this.timeBoxShow1 = false;
                this.currentPage = 1; // 重置到第一页
                this._tableAttempting()
            },
            clearAnalysTimeVal(){
                this.sTime = '';
                this.eTime = '';
                this.FilterTimeArr.forEach(v => v.active = false)
                this.FilterTimeArr[0].active = true;
                this.timeBoxShow2 = false;
                this._listAnalysis()
            },
            submitFn(){
                // 验证时间字段
                this.startQueryTime = this.filterDateArr[this.filterDateType].startQueryTime;
                this.endQueryTime = this.filterDateArr[this.filterDateType].endQueryTime;
                console.log(this.startQueryTime,'this.startQueryTime')
                console.log(this.endQueryTime,'this.endQueryTime')
                if (this.startQueryTime || this.endQueryTime) {
                    if (!this.startQueryTime || !this.endQueryTime) {
                        this.$message('开始时间和结束时间必须同时填写');
                        return;
                    }

                    // 将时间字符串转换为时间戳进行比较
                    const startTime = new Date(this.startQueryTime).getTime();
                    const endTime = new Date(this.endQueryTime).getTime();

                    if (startTime > endTime) {
                        this.$message('开始时间不能大于结束时间');
                        return;
                    }
                }
                if (this.tabNum == 1){
                    this.currentPage = 1; // 筛选时重置到第一页
                    this._tableAttempting();
                } else {
                    this._listAnalysis()
                }
            },
            consleDate(e){
                console.log(e)
            },
            submitAnalysisFn(){
                // 验证时间字段
                if (this.sTime || this.eTime) {
                    if (!this.sTime || !this.eTime) {
                        // uni.showToast({
                        //     title: '开始时间和结束时间必须同时填写',
                        //     icon: 'none'
                        // });
                        return;
                    }

                    // 将时间字符串转换为时间戳进行比较
                    const startTime = new Date(this.sTime).getTime();
                    const endTime = new Date(this.eTime).getTime();

                    if (startTime > endTime) {
                        // uni.showToast({
                        //     title: '开始时间不能大于结束时间',
                        //     icon: 'none'
                        // });
                        return;
                    }
                }
                this.timeBoxShow2 = true;
                this.filterTimesShow = false;
                this._listAnalysis()
            },
            closeTimeRange(){
                this.timeShow = false;
                this.startTimeShow = false;
                this.endTimeShow = false;
                this.startTimePopShow = false;
                this.endTimePopShow = false;
            },

            // 分页处理
            handleSizeChange(pageSize) {
                this.pageSize = pageSize;
                this.currentPage = 1;
                this._tableAttempting();
            },
            handlePageChange(currentPage) {
                this.currentPage = currentPage;
                this._tableAttempting();
            },

            // 数据统计 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
        },
    };
</script>
<style lang="scss" scoped>
    // 数据统计 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
    .b-marT-10{
        margin-top: 10px;
    }
    .b-marT-20{
        margin-top: 20px;
    }
    /* flex布局 */
    .flex-depart-left{
        display: flex;
        align-items: center;
    }
    .flex-depart-center{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .flex-depart-center-center{
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .flex-depart-center-end{
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }

    .flex-depart-top{
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
    }
    .flex-depart-left-warp{
        display: flex;
        align-items: center;
        flex-wrap: wrap;
    }
    .flex-depart-center-top{
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .flex-depart-left-center{
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }

    /*大图排序*/
    .flex-depart-column-top-left{
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
    }
    .drawBottomBtn{
        width: 100%;
        height: 70px;
        position: absolute;
        left: 0;
        bottom: 0;
        box-sizing: border-box;
        padding-right: 20px;
    }
    .drawerOutBox{
        padding: 0 20px;
        height: 100%;
        position: relative;
    }
    .tabs-box{
        height: 45px;
        width: 300px;
        /*background-color: white;*/
        display: flex;
        justify-content: space-around;
        align-items: center;
        /*border-bottom: 1px solid #eee;*/
    }
    .tabs-item{
        position: relative;
        width: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        cursor: pointer;
        span{
            color: #A7ADC6;
            font-weight: bold;
        }
    }
    .blue-tiao{
        width: 21px;
        height: 4px;
        background: #1877ff;
        border-radius: 2px;
        position: absolute;
        bottom: 0;
        left: 50%;
        margin-left: -10.5px;
        display: inline-block;
    }
    // ... 保持不变 ...
    .scroll-view_H{
        width: 100%;
        padding: 10px;
        box-sizing: border-box;
    }
    .table-box{
        padding: 0 10px 10px;
        background-color: white;
    }
    .table-box2{
        margin-bottom: 10px;
    }
    .filter-time-box{
        padding: 10px 10px 10px;
        background-color: white;
        margin-top: 10px;
    }
    .f-top{
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 120px;
        height: 33px;
        border: 1px solid #e9e9e9;
        border-radius: 17px;
        padding: 0 10px;
        image{
            width: 14px;
            height: 16px;
        }
        .txt{
            font-size: 14px;
        }
    }
    .time-box{
        height: 42px;
        background: #f7f7f7;
        border: 1px solid #dcdde0;
        border-radius: 4px;
        margin-top: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;
        padding: 0 12.5px;
        text{
            font-size: 14px;
            color: #1877FF;
        }
    }
    .bottomBtn-box{
        width: 100%;
        height: 70px;
        padding-bottom: calc(-18.5px + env(safe-area-inset-bottom));
        position: fixed;
        left: 0;
        bottom: 0;
        z-index: 9999999;
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        padding-left: 15px;
        padding-right: 15px;
        .btn{
            width: 100%;
            height: 50px;
            background: #1877ff;
            border-radius: 25px;
            font-size: 16px;
            font-weight: bold;
            color: white;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }
    .reject-con{
        background: #ffffff;
        border-radius: 8px;
        overflow: hidden;
        position: relative;
        .close-xsxq{
            position: absolute;
            right: 10px;
            top: 15px;
            image{
                height: 20px;
                width: 20px;
            }
        }
        .top-title{
            height: 45px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-bottom: 1px solid #E7E7E7;

            text{
                font-size: 18px;
                font-weight: bold;
                color: #2b2f36;
            }
            .re-close{
                position: absolute;
                right: 10px;
                top: 14px;
            }
        }
    }
    .tishi-title{
        line-height: 50px;
        border-bottom: 1px solid #eee;
        font-weight: 600;
        font-size: 16px;
        text-align: center;
        color: #333;
        text{
            color: #4A73F8;
        }
    }
    .s-times-box{
        display: flex;
        display: -webkit-flex;
        justify-content: space-between;
        flex-direction: row;
        flex-wrap: wrap;
        padding: 10px 5px;
    }
    .times-item{
        width: 80px;
        height: 30px;
        background: rgba(24,119,255,0.05);
        border: 0.5px solid rgba(24,119,255,0.20);
        color: #1877ff;
        border-radius: 15px;
        text-align: center;
        line-height: 30px;
        margin: 5px 3px;
        font-size: 13px;
        cursor: pointer;
    }
    // ... 其余样式继续转换 ...
    .sort-box{
        width: 94%;
        margin: 0 auto;
        padding: 15px 0px;
        border-top: 1px solid #eee;
    }
    .sort-title{
        font-size: 15px;
        color: #555555;
        margin-bottom: 10px;
        font-weight: bold;
    }
    .nextBtn{
        width: 94%;
        margin: 0 auto;
        height: 50px;
        background: #1877ff;
        border-radius: 25px;
        color: white;
        font-size: 16px;
        text-align: center;
        line-height: 50px;
    }
    .t-box{
        width: 155px;
        height: 44px;
        background: #f7f7f7;
        border: 1px solid #dcdde0;
        border-radius: 4px;
        box-sizing: border-box;
        padding-left: 10px;
        font-size: 14px;
        color: #7E7E81;
    }
    // ... 继续保持相同的转换规则 ...
    .wx-avatar {
        width: 30px;
        height: 30px;
        border-radius: 50%;
    }
    // ... 其他样式继续转换 ...
    .nodata-box{
        height: 375px;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        img{
            width: 87px;
            height: 96px;
            margin-bottom: 10px;
        }
        span{
            font-size: 15px;
            color: #a7adc6;
        }
    }
    .drawer-nav-top{
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 60px;
        span{
            font-size: 18px;
            color: black;
            font-weight: bold;
        }
        i{
            cursor: pointer;
            font-size: 18px;
        }
    }
    .act-tabs-style{
        color: #323B5A !important;
    }
    .btns-box{
        padding-right: 10px;
    }
    .comm-btn{
        width: 128px;
        height: 35px;
        text-align: center;
        line-height: 35px;
        cursor: pointer;
        border-radius: 23px;
        span{
            font-size: 14px;
        }
    }
    .btn1{
        border: 1px solid #929292;
    }
    .btn2{
        border: 1px solid #1877ff;
        background-color: #1877ff;
        span{
            color: white;
        }

    }

    .no-wrap {
        max-width: 200px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
    .colorBlue{
        color: #1877ff;
        cursor: pointer;
    }
    .table-width{
        /*width: calc(100% - 10px);*/
    }
    .times-item-active{
        background-color: #1877ff;
        color: #fff;
    }

    .tips{
        font-size: 12px;
        text-align: left;
        color: #a7adc6;
        line-height: 17px;
        margin-top: 10px;
        padding-left: 10px;
    }
    .s-analysis{
        padding: 10px;
    }

    .t-title {
        font-size: 16px;
        font-weight: bold;
        color: #333;
        padding: 10px 0;
        margin-bottom: 10px;
    }
    .s-analysis .table thead th{
        width: 33.3%;
    }
    .position-relative a{
        height: 100%;
        width: 100%;
        display: inline-block;
        opacity: 0;
        position: absolute;
        left: 0;
        top: 0;
    }
    .swiper-img{
        height: 500px;
        width: auto;
    }


    // 数据统计 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
</style>
